import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import LoginPage from "./pages/login/index";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import ForgotPasswordUserNotFoundPage from "./pages/login/ForgotPasswordUserNotFoundPage";
import VerifyOtpPage from "./pages/login/VerifyOtpPage";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import { PanelPage } from "./pages/panel/index";
import { ColorsPage } from "./pages/panel/color/index";
import { UsersPage } from "./pages/panel/users/index";
import { ProductsPage } from "./pages/panel/products/index";
import { CategoriesPage } from "./pages/panel/categories/index";
import { InvoicesPage } from "./pages/panel/invoices/index";
import { PaymentsPage } from "./pages/panel/payments/index";
import ProtectedRoute from "./components/ProtectedRoute";
import PWAStatusBar from "./components/PWAStatusBar";
import { initInstallPrompt } from "./utils/pwaUtils";
export { API_BASE_URL } from "./config/api";

function App() {
  const { authToken, id } = useSelector((state) => state.loginData || {});
  const isAuthenticated = authToken && id;

  // Initialize PWA features
  useEffect(() => {
    initInstallPrompt();
  }, []);

  return (
    <>
      <PWAStatusBar />
      <Router>
        <Routes>
          {/* Root route - redirect based on auth status */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/panel/orders" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/forgotpassword/not-found" element={<ForgotPasswordUserNotFoundPage />} />
          <Route path="/verifyotp" element={<VerifyOtpPage />} />
          <Route path="/resetpassword" element={<ResetPasswordPage />} />

          {/* Protected Routes — Staff/Dealer: orders + invoices only; Admin: all */}
          <Route
            path="/panel"
            element={
              <ProtectedRoute>
                <PanelPage />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="orders" replace />} />
            <Route path="orders" element={null} />
            <Route path="estimates" element={null} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route
              path="colors"
              element={
                <ProtectedRoute adminOnly>
                  <ColorsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="categories"
              element={
                <ProtectedRoute adminOnly>
                  <CategoriesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="products"
              element={
                <ProtectedRoute adminOnly>
                  <ProductsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute adminOnly>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="payments"
              element={
                <ProtectedRoute adminOnly>
                  <PaymentsPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
